import { render, staticRenderFns } from "./SortableGrid.vue?vue&type=template&id=2677e42b&scoped=true"
import script from "./SortableGrid.vue?vue&type=script&lang=js"
export * from "./SortableGrid.vue?vue&type=script&lang=js"
import style0 from "./SortableGrid.vue?vue&type=style&index=0&id=2677e42b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677e42b",
  null
  
)

export default component.exports